import { makeStyles } from '@material-ui/core/styles';
import { indigo, blue } from '@material-ui/core/colors';

//Colors
const lightBlue = indigo[200];
const darkerBlue = blue[600];

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  tabsRoot: {
    marginBottom: theme.spacing(4)
  },
  tabs: {
    '& a': {
      borderRadius: 40,
      marginRight: theme.spacing(2),
      '&.active': {
        backgroundColor: '#0F78FF',
        color: 'white'
      }
    }
  },
}));

export default useStyles;
